import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KEY = "cookie_consent_v1";

function getConsent(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function setConsent(value: "accepted" | "rejected") {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* ignore */
  }
  document.cookie = `cookie_consent=${value}; Path=/; Max-Age=${60 * 60 * 24 * 365}; SameSite=Lax`;
}

export function CookieBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  if (!visible) return null;

  const accept = () => {
    setConsent("accepted");
    setVisible(false);
  };
  const reject = () => {
    setConsent("rejected");
    setVisible(false);
  };

  return (
    <div
      id="cookie-banner"
      style={{ position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 9999 }}
    >
      <div
        className="card"
        style={{
          display: "flex",
          gap: "1rem",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <div style={{ maxWidth: 900 }}>
          <b>{t("cookies.banner.title")}</b>
          <div className="summary-card-meta">
            {t("cookies.banner.text")}{" "}
            <Link to="/legal/cookies">{t("cookies.banner.learn_more")}</Link>.
          </div>
        </div>
        <div style={{ display: "flex", gap: "0.5rem" }}>
          <button type="button" className="btn btn-secondary btn-sm" onClick={reject}>
            {t("cookies.banner.reject")}
          </button>
          <button type="button" className="btn btn-primary btn-sm" onClick={accept}>
            {t("cookies.banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
